import template from './template.html'
import controller from './promoBody.controller'

export default {
  restrict: 'E',
  template,
  bindings: {
    storyObj: '<',
    companySettingsObj: '<',
  },
  controller,
  controllerAs: 'vm',
}
